import React, { FC } from "react";
import Footer from "./Footer";
import Header from "./Header";

interface Props {
    children: React.ReactNode;
}

const HeaderFooter: FC<Props> = ({ children }) => {
    return (
        <>
            <Header />
            {children}
            <Footer />
        </>
    );
}

export default HeaderFooter;